import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { toList3jhuyej2anx2q as toList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { SortParte7ewatwctfe4 as SortPart } from './SortPart.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var SortBuilderClass;
function SortBuilder() {
  if (SortBuilderClass === VOID) {
    class $ {
      constructor() {
        this.sortParts_1 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
      }
      add_od000q_k$(sort) {
        this.sortParts_1.add_utx5q5_k$(sort);
      }
      build_1k0s4u_k$() {
        return toList(this.sortParts_1);
      }
      sort_f59woj_k$(_this__u8e3s4, ascending) {
        return this.add_od000q_k$(new (SortPart())(_this__u8e3s4, ascending));
      }
      ascending_ijynum_k$(_this__u8e3s4) {
        return this.sort_f59woj_k$(_this__u8e3s4, true);
      }
      descending_tl4o2_k$(_this__u8e3s4) {
        return this.sort_f59woj_k$(_this__u8e3s4, false);
      }
    }
    initMetadataForClass($, 'SortBuilder', SortBuilder);
    SortBuilderClass = $;
  }
  return SortBuilderClass;
}
//region block: exports
export {
  SortBuilder as SortBuilder36qqny2jtmmgx,
};
//endregion

//# sourceMappingURL=SortBuilder.mjs.map
